import React from "react";
import Code from "../components/code/code";
var CodesPage = function CodesPage() {
    return /*#__PURE__*/ React.createElement(Code, null);
};
export default CodesPage;
